import React from 'react';
import { AppBar, Tabs, Tab, Button } from '@mui/material';

import './contact.scss';
import { Map } from '../../assets';
import { useEvents } from '../../context';
import { useWindowDimensions } from '../../hooks';
import { Theme } from '../../config';
import { Navbar, BookForm, QueryForm, Footer } from '..';

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`
    };
}

export const ContactPage: React.FC = React.memo(() => {
    const { width } = useWindowDimensions();
    const { contactValue } = useEvents();
    const [value, setValue] = React.useState<number>(contactValue);
    const topRef = React.useRef<HTMLElement>(null);

    React.useEffect(() => {
        if (topRef.current) {
            topRef.current.scrollIntoView();
        }
    }, []);

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setValue(newValue);
    };

    return (
        <section ref={topRef}>
            <Navbar contact={true} />
            <div
                style={{
                    padding: width > 1350 ? '6rem 8vw' : '6rem 5vw',
                    background: Theme.background
                }}
            >
                <div className='contact--book'>
                    <div className='contact--book__tabs'>
                        <AppBar position='relative' style={{ zIndex: 1 }}>
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                aria-label='simple tabs example'
                                textColor='inherit'
                                indicatorColor='secondary'
                            >
                                <Tab label='Book Appointment' {...a11yProps(0)} />
                                <Tab label='Queries' {...a11yProps(1)} />
                            </Tabs>
                        </AppBar>
                        {value === 0 && <BookForm />}
                        {value === 1 && <QueryForm />}
                    </div>
                </div>
                <div className='contact__directions-buttons'>
                    <Button
                        fullWidth
                        href='https://www.google.com/maps/place/Prispek+Consulting/@-25.6873846,28.231015,15z/data=!4m5!3m4!1s0x0:0x6d737c2de80ddf05!8m2!3d-25.6868226!4d28.2322884'
                        target='_blank'
                        rel='noopener noreferrer'
                        variant='text'
                        color='inherit'
                        style={{ background: Theme.lightYellow }}
                        size='large'
                    >
                        Take me to Prispek, Spektra or Prisma
                    </Button>
                </div>
                <div className='contact--details'>
                    <a
                        draggable={false}
                        href='https://www.google.com/maps/place/Prispek+Consulting/@-25.6873846,28.231015,15z/data=!4m5!3m4!1s0x0:0x6d737c2de80ddf05!8m2!3d-25.6868226!4d28.2322884'
                        className='contact--details__map'
                        target='_blank'
                        rel='noopener noreferrer'
                    >
                        <img draggable={false} src={Map} alt='Prispek Maps' />
                    </a>
                </div>
            </div>
            <Footer />
        </section>
    );
});
